<template>
  <div :class="{ mobile: isMobile }">
    <div class="title-wrapper">
      <span class="title" :class="{ active: index === 0 }" @click="index = 0"
        >History</span
      >
      <span class="title" :class="{ active: index === 1 }" @click="index = 1"
        >Triggers</span
      >
      <span class="title" :class="{ active: index === 2 }" @click="index = 2"
        >Rules</span
      >
      <span class="title" :class="{ active: index === 3 }" @click="index = 3"
        >Actions</span
      >
    </div>
    <div v-if="index === 0" class="content-wrapper">
      <HistoryTable
        :historyDataList="alertDataObj.historyDataList"
      ></HistoryTable>
    </div>
    <div v-if="index === 1" class="content-wrapper">
      <TriggerTable
        :triggerDataList="alertDataObj.triggerDataList"
        @onViewTriggerHistory="viewTriggerHistory"
      ></TriggerTable>
    </div>
    <div v-if="index === 2" class="content-wrapper">
      <Rules
        :triggerOnNumHits="alertDataObj.triggerOnNumHits"
        :triggerOnFirstHit="alertDataObj.triggerOnFirstHit"
      ></Rules>
    </div>
    <div v-if="index === 3" class="content-wrapper">
      <Actions :alertEmailContact="alertDataObj.emailContact"></Actions>
    </div>
  </div>
</template>

<script>
import HistoryTable from './HistoryTable.vue';
import TriggerTable from './TriggerTable.vue';
import Rules from './Rules.vue';
import Actions from './Actions.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'AlertDetailContainer',
  components: { HistoryTable, TriggerTable, Rules, Actions },
  props: {
    alertDataObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      index: 0
    };
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  methods: {
    ...mapActions('alertsSuspiciousTrafficStore', ['fetchTrigger']),
    ...mapMutations('alertsSuspiciousTrafficStore', [
      'setSelectedTriggerWithAlertInfo'
    ]),
    viewTriggerHistory(trigger) {
      const { alertId, name } = this.alertDataObj;

      this.fetchTrigger({ trigger, isTriggerOfSelectedAlert: true });

      this.setSelectedTriggerWithAlertInfo({
        trigger,
        alertId,
        alertName: name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title-wrapper {
  margin-bottom: 0.5rem;
  border-bottom: 1px solid $border-grey;

  .title {
    display: inline-block;
    margin: 0 1rem;
    padding: 0.5rem;
    padding-top: 0;
    cursor: pointer;

    &.active {
      border-bottom: 2px solid $text-light-blue;
    }
  }

  .title:nth-child(1) {
    margin-left: 0;
  }
}

.content-wrapper {
  margin: 0 0.5rem;
}

.mobile {
  .title-wrapper {
    display: flex;
    justify-content: space-between;

    .title {
      padding: 0.25rem;
      margin: 0 0.25rem;
    }

    .title:nth-child(1) {
      margin-left: 0;
    }
  }
}
</style>
